// those file are generate by npm run i18n
  export default {
  "user": {
    "subtitle": "ЖИЛИЙН ТОЙМ",
    "note": "*Энэ тоймд багтсан бүх статистик 2025/12/31-ны өдрийн байдлаар болно."
  },
  "handCard": {
    "text": "{date}\nТа 2025 онд анх NUTS POKER тоглосон байна."
  },
  "report": {
    "loginTime": "Үүнээс хойш NUTS POKER тантай \n{loginDay}\nхамт байжээ.",
    "loginTips": "*2025 онд NUTS POKER-т нэвтэрсэн өдрийн тоо",
    "enjoyTime": "Таны хувьд хамгийн тухтай цаг \n{loginTime}\nбайжээ! Энэ нь таны NUTS POKER нээх дуртай цаг юм!",
    "firstHandDate": "{first_hand_date}\nТа {first_hand_type} тоглоод энэ жилийн анхны гарын хөзрөө авсан байна. \n{first_hand_cards}"
  },
  "hands": {
    "v1": "Та энэ жил NUTS POKER-т нийт \n{hands}\nтоглосон байна\nТаны покерт дурлах сонирхол нийт тоглогчдын \n{percentage}-с илүү гарчээ.",
    "v2": "Энэ жил NUTS POKER-т та нийт \n{hands}\nтоглосон байна\nБидний аяллын нэг хэсэг байсанд баярлалаа!",
    "v3": "Энэ жил NUTS POKER-т та нийт \n{hands}\nтоглосон байна\nNUTS POKER дараа жил улам сайжирч, танд илүү сайн туршлага өгөхийг зорьж байна!"
  },
  "hardTime": {
    "date": "{one_day_hands}\nЭнэ таны NUTS POKER дахь хамгийн хичээл зүтгэлтэй өдөр байлаа.",
    "hands": "Тухайн өдөр та нийт \n{one_day_hands_num} {longHands}\nтогложээ."
  },
  "favoriteGame": "Таны тоглосон нийт газрын хөзрөөс \n{handsNum} {hands} таны дуртай тоглоомын хэлбэрээр ашиглагдсан байна, {game}",
  "kkWin": {
    "v1": "2025 онд та нийт \n{all} {longTimes}\nKK авсан бөгөөд \nөрсөлдөгчөө KK-ээр \n{win} {longTimesTwo}\nялсан байна",
    "v2": "Энэ жил та нийт \n{all} {threeTimes}\nAll-in бооцоо тавьсан байна.\nТаны All-in хожлын хувь:\n{percentage}\nПокер бол зоригтой хүмүүсийн тоглоом !"
  },
  "achievement": {
    "spinup": "{spinup_date}\nтаны хамгийн азтай өдөр байжээ.",
    "spinup_2": "{spinup_ratio} удаа удаа SpinUp үржүүлэгч онож \n{spinup_reward}\n-г хожсон байна.",
    "mtt": "{mtt_date}\nтаны энэ жилийн хамгийн онцлох өдөр байжээ.",
    "mtt_2": "Тэр өдөр\nта {mtt_name}-н {no} {mtt_rank}-д\nорж, {mtt_reward}\nхожсон",
    "rg": "{rg_date}\nТаны покерын аяллын онцлох өдөр!",
    "rg_2": "Та тухайн өдөр жилийн хамгийн том бооцоогоо хожсон байна: \n{rg_reward}"
  },
  "lucky": {
    "title": "Гарын мод бүр\nөөр түүх өгүүлнэ.",
    "luckyHand": "АЗТАЙ\nГАРЫН МОД",
    "unLuckyHand": "АЗГҮЙ\nГАРЫН МОД",
    "luckyRate": "Хожлын хувь:{lucky_rate}",
    "unLuckyRate": "Хожлын хувь\n{unlucky_rate}",
    "luckyText": "{lucky_hand} баатрын дүрд тоглосон.\nТанд боломж байх үед {lucky_rate} удаа хожсон!",
    "unLuckyText": "Болгоомжтой байгаарай {unlucky_hand}…\nТа энд нийтдээ ердөө {unlucky_rate} удаа хожиж байсан.",
    "note": "*Зөвхөн 10 ба түүнээс дээш удаа тараагдсан гарын модыг тооцно."
  },
  "futureStory": "NUTS POKER нь 2026 онд тантай хамт таны покерын аяллын түүхийг үргэлжлүүлэн бичихийг тэсэн ядан хүлээж байна.",
  "version3": {
    "text": "Харамсалтай нь та 2025 онд NUTS POKER дээр  ямар ч дурсамж үлдээгээгүй байна.",
    "continue": "2026 онд NUTS POKER-ын\nдараагийн аяллаа бүтээгээрэй!",
    "tips": "*Бүх статистикийг 2024-12-31-ний байдлаар гаргав."
  },
  "button": {
    "save": "Зураг хадгал",
    "copy": "Хуулж хуваалцах"
  },
  "unit": {
    "days": "хоног",
    "hands": "гарын",
    "longHands": "гарын",
    "longTimes": "удаа",
    "longTimesTwo": "удаа",
    "threeTimes": "удаа",
    "times": "удаа",
    "multiplier": "удаа",
    "num": "№",
    "num2": "-т",
    "bets": "бооцоо тавьжээ",
    "skUnits": ""
  },
  "toast": {
    "linkCopied": "Холбоосыг хууллаа",
    "imageSaved": "Зургийг хадгаллаа"
  }
}
  